<template>
  <v-dialog v-model="dialog" max-width="1000px" persistent>
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
      >
        <v-icon>mdi-import</v-icon>
        Import
      </v-btn>
    </template>
    <v-card>
      <v-toolbar>
        <v-toolbar-title class="grey--text text--darken-4">Import words</v-toolbar-title>
      </v-toolbar>
      <v-container>
        <v-layout wrap align-center>
          <v-flex xs9 v-if="word">
            <span class="display-2">{{ word.text }}</span>
          </v-flex>
          <v-flex xs3 style="text-align: center">
            <div v-if="!loading">Should to import<br><strong class="title">{{ total }}</strong></div>
            <v-progress-circular
              v-if="loading"
              :size="50"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </v-flex>
          <v-flex xs3 v-if="word">
            <v-btn @click="takeWord">Skip</v-btn>
            <v-btn @click="ignoreWord(word)" :loading="ignoreLoading">Ignore</v-btn>
          </v-flex>
          <v-flex xs6 offset-xs3>
            <v-select
              :items="categories"
              v-model="categoryId"
              item-text="fullNameWithCounter"
              item-value="id"
              placeholder="All categories"
              clearable
            ></v-select>
          </v-flex>
        </v-layout>
      </v-container>
      <v-divider></v-divider>
      <ImportedWordForm v-if="word" :baseWord="word" :baseCategories="categories" @close="dialog = false" @imported="onImported"></ImportedWordForm>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ImportedWordForm from './ImportedWordForm'
import { SourceDictionariesApi } from '../common/api'

export default {
  components: { ImportedWordForm },
  data () {
    return {
      dialog: false,
      categories: [],
      categoryId: null,
      words: [],
      total: 0,
      word: null,
      loading: false,
      ignoreLoading: false
    }
  },
  computed: {
    ...mapState([
      'sourceDictionary'
    ]),
    ...mapGetters([
      'sourceLanguageId'
    ])
  },
  watch: {
    dialog (val) {
      if (val) {
        this.loadCategories()
        this.load()
      } else {
        this.categories = []
        this.words = []
        this.word = null
      }
    },
    categoryId (val) {
      this.word = null
      this.load()
    }
  },
  async created () {
    await this.loadCategories()
  },
  methods: {
    close () {
      if (this.saving) {
        return
      }
      this.dialog = false
    },
    async load () {
      this.loading = true
      try {
        const { data } = await SourceDictionariesApi.baseWords(this.sourceDictionary, {
          categoryId: this.categoryId
        })
        this.total = data.total
        this.words = data.items
        if (!this.word) {
          this.takeWord()
        }
      } finally {
        this.loading = false
      }
    },
    async loadCategories () {
      const { data } = await SourceDictionariesApi.importedCategories(this.sourceDictionary)
      this.categories = data.map(category => { return { ...category, fullNameWithCounter: `${category.fullName} (${category.total})` } })
    },
    async takeWord () {
      if (this.total === 0) {
        this.word = null
        return
      }

      this.word = this.words.shift()

      if (this.words.length < 3 && this.total >= 3) {
        await this.load()
      }
    },
    async onImported () {
      this.total--
      this.takeWord()
    },
    async ignoreWord (word) {
      this.ignoreLoading = true
      try {
        await SourceDictionariesApi.ignoreBaseWord(this.sourceDictionary, word)
        this.total--
      } finally {
        this.ignoreLoading = false
      }
      await this.takeWord()
    }
  }
}
</script>
